import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  Tooltip,
  CircularProgress,
  Checkbox
} from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import Swal from "sweetalert2";
import InfoIcon from "@mui/icons-material/Info";

import { common_axios } from "../../../App";
// import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "../../../components/Loader";
import MessageRoundedIcon from "@mui/icons-material/MessageRounded";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import axios from "axios";
import { dateFormatter } from "../../../helper/helper";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import ResellerDate from "./ResellerDate";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Stack from "@mui/material/Stack";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Fab from "@mui/material/Fab";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { BorderBottom } from "@mui/icons-material";
import LogsMultiSelect from "./LogsMultiSelect";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import BookIcon from "@mui/icons-material/Book";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import XLSX from "xlsx";
import Pagination from "@mui/material/Pagination";
import DownloadLogs from "./DownloadLogs";
import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function ViewLogs() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const [downloadModelOpen, setDownloadModel] = useState(undefined);

  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    // console.log("date11--", date);
    setDownloadModel(cell.row.original);
    // setTableLoaderIndex(index);
    await modelButtonDownload.current.click();
  };
  const [dataSenderid, setDataSenderid] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState();
  const [tableShow, setTableShow] = useState(true);
  const [defaultHitApi, setDefaultHitApi] = useState(false);
  const [defaultHitPartialSearch, setDefaultHitPartialSearch] = useState(true);
  const [MoreFilters, setMoreFilters] = useState(false);
  const [hideSkeleton1, setHideSkeleton1] = useState();
  const [MenuItemChange, setMenuItemChange] = useState();
  const [accountcountryid, setAccountCountryId] = useState("");
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [userState, setUserState] = React.useState([]);
  const [data2, setData2] = React.useState([]);
  const [data3, setData3] = React.useState([]);
  const [hideSkeleton2, setHideSkeleton2] = useState(false);
  const [loading, setLoading] = useState(false);

  const [filterSet, setFilterSet] = React.useState("logs");
  const [open1, setOpen1] = useState(null);
  const [channelList, setChannelList] = useState([]);
  const [channelState, setChannelState] = React.useState([]);
  const [data, setData] = useState([]);
  // console.log("yt", userState);
  const [data1, setData1] = useState([]);
  const onKeyDown = (e) => {
    e.preventDefault();
  };
  const [paginationPage, setPaginationPage] = React.useState(1);
  const [disableBtn, setDisableBtn] = useState(false);
  const [disableBtn1, setDisableBtn1] = useState(false);

  const [TableStatus, setTableStatus] = useState({
    pageNo: 0,
    pageSize: 10,
  });
  const [open, setOpen] = useState();
  const initialStatee = {
    exactMatch: true,
    messageId: "",
    msidn: "",
    viewMore: true,
    selector1: "",
    startDate: null,
    endDate: null,
    statusCheckbox: null,
    toDestination: "",
    fromDestination: [],
    showMoreFilters: false,
    searchlog: "",
  };
  const [filters, setFilters] = useState(initialStatee);
   console.log("firsteee", filterSet);
  // const columns = useMemo(
  //   () =>
  //   [
  //     {
  //       Header: "Id",

  //       accessor: "id", // accessor is the "key" in the data
  //       Cell: (cell) => {
  //         // console.log("cell--", cell.row.index);
  //         return (
  //           <>
  //             {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
  //           </>
  //         );
  //       },
  //     },

  //     {
  //       Header: "Message Id",

  //       accessor: "smslogId", // accessor is the "key" in the data
  //     },
  //     {
  //       Header: "Mobile No",

  //       accessor: "pdst", // accessor is the "key" in the data
  //     },
  //     {
  //       Header: "From",

  //       accessor: "psrc", // accessor is the "key" in the data
  //     },

  //     // {
  //     //   Header: "Status",

  //     //   accessor: "status", // accessor is the "key" in the data,
  //     //   Cell: (cell) => {
  //     //     return (
  //     //       <>
  //     //         {cell.row.original.approved == 0 ? (
  //     //           <div className="badge badge_8 bg-warning">Pending</div>
  //     //         ) : cell.row.original.approved == 1 ? (
  //     //           <div className="badge badge_8 bg-success">Approved</div>
  //     //         ) : (
  //     //           <div className="badge badge_8 bg-danger">Rejected</div>
  //     //         )}
  //     //       </>
  //     //     );
  //     //   },
  //     // },

  //     {
  //       Header: "Type",

  //       accessor: "psmstype",
  //       Cell: (cell) => {
  //         return (
  //           <>
  //             {cell?.row?.original?.psmstype == "Promotional" ? (
  //               <div className="">P</div>
  //             ) : (
  //               <div className="">T</div>
  //             )}
  //           </>
  //         );
  //       },
  //     },
  //     {
  //       Header: "Date",

  //       accessor: "pdatetime", // accessor is the "key" in the data
  //       Cell: (cell) => {
  //         return (
  //           <>
  //             <div>
  //               {cell?.row?.original?.pdatetime?.split(" ")?.map((dataaa) => {
  //                 return (
  //                   <>
  //                     <span style={{ whiteSpace: "nowrap" }}>{dataaa}</span>
  //                     <br />
  //                   </>
  //                 );
  //               })}
  //             </div>
  //           </>
  //         );
  //       },
  //     },
  //     // {
  //     //   Header: "Message",

  //     //   accessor: "pmsg",
  //     // },

  //     {
  //       Header: "Message",
  //       accessor: "pmsg", // accessor is the "key" in the data
  //       Cell: (cell) => {
  //         return (
  //           <>
  //             {cell.row.original.pmsg.length >= 60 ? (
  //               <div className="">
  //                 <div className="showMoreTd">
  //                   {cell.row.original?.[`Show`]
  //                     ? cell.row.original.pmsg?.slice(0, 60) + "..."
  //                     : cell.row.original.pmsg}
  //                 </div>
  //                 <button
  //                   className="showMore"
  //                   onClick={() => {
  //                     // Showdata?.[`Show${cell.row.index}`];

  //                     const dataaa = [...data];

  //                     dataaa[cell.row.index][`Show`] =
  //                       !cell.row.original?.[`Show`];

  //                     setData(dataaa);
  //                   }}
  //                 >
  //                   {cell.row.original?.[`Show`] ? "More" : "Less"}
  //                 </button>
  //               </div>
  //             ) : (
  //               <div className="showMoreTd">{cell.row.original.pmsg}</div>
  //             )}
  //           </>
  //         );
  //       },
  //     },
  //     // {
  //     //   Header: "Status",

  //     //   accessor: "log", // accessor is the "key" in the data
  //     //   Cell: (cell) => {
  //     //     return (
  //     //       <>

  //     //           <div className="mb-2">{`(${cell?.row?.original?.log})`}</div>

  //     //       </>
  //     //     );
  //     //   },
  //     // },

  //     {
  //       Header: "Status",

  //       accessor: "log", // accessor is the "key" in the data
  //       Cell: (cell) => {
  //         return (
  //           <>
  //             {cell.row.original.pstatus == 2 ? (
  //               <div
  //                 className="badge bg-warning activated_1"
  //                 // style={{ width: "71% !important" }}
  //               >
  //                 {/* Message Pushed {"    "} */}
  //                 {cell?.row?.original?.log}
  //               </div>
  //             ) : (
  //               <div
  //                 className="badge bg-success activated_1"
  //                 // style={{ width: "71% !important" }}
  //               >
  //                 {cell?.row?.original?.log}
  //               </div>
  //             )}
  //           </>
  //         );
  //       },
  //     },

  //     // {
  //     //   Header: "Creation Date",

  //     //   accessor: "requestDate", // accessor is the "key" in the data

  //     // },
  //   ],
  //   [data, TableStatus.pageNo, TableStatus.pageSize]
  // );

  const columns = useMemo(
    () =>
      filterSet == "logs"
        ? [
            {
              Header: "Id",

              accessor: "id", // accessor is the "key" in the data
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>
                    {cell.row.index +
                      1 +
                      TableStatus?.pageNo * TableStatus?.pageSize}
                  </>
                );
              },
            },

            {
              Header: "Message Id",

              accessor: "smslogId", // accessor is the "key" in the data
            },
            {
              Header: "Mobile No",

              accessor: "pdst", // accessor is the "key" in the data
            },
            {
              Header: "From",

              accessor: "psrc", // accessor is the "key" in the data
            },

            {
              Header: "Type",

              accessor: "psmstype",
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.psmstype == "Promotional" ? (
                      <div className="">P</div>
                    ) : (
                      <div className="">T</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Date",

              accessor: "pdatetime", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.pdatetime
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span style={{ whiteSpace: "nowrap" }}>
                                {dataaa}
                              </span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },
            // {
            //   Header: "Message",

            //   accessor: "pmsg",
            // },

            {
              Header: "Message",
              accessor: "pmsg", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell?.row?.original?.pmsg?.length >= 60 ? (
                      <div className="">
                        <div className="showMoreTd">
                          {cell?.row?.original?.[`Show`]
                            ? cell?.row?.original?.pmsg?.slice(0, 60) + "..."
                            : cell?.row?.original?.pmsg}
                        </div>
                        <button
                          className="showMore"
                          onClick={() => {
                            // Showdata?.[`Show${cell.row.index}`];

                            const dataaa = [...data];

                            dataaa[cell.row.index][`Show`] =
                              !cell.row.original?.[`Show`];

                            setData(dataaa);
                          }}
                        >
                          {cell.row.original?.[`Show`] ? "More" : "Less"}
                        </button>
                      </div>
                    ) : (
                      <div className="showMoreTd">{cell.row.original.pmsg}</div>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Status",

            //   accessor: "log", // accessor is the "key" in the data
            //   Cell: (cell) => {
            //     return (
            //       <>

            //           <div className="mb-2">{`(${cell?.row?.original?.log})`}</div>

            //       </>
            //     );
            //   },
            // },

            {
              Header: "Status",

              accessor: "log", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.pstatus == 2 ? (
                      <div
                        className="badge bg-warning activated_1"
                        // style={{ width: "71% !important" }}
                      >
                        {/* Message Pushed {"    "} */}
                        {cell?.row?.original?.log}
                      </div>
                    ) : (
                      <div
                        className="badge bg-success activated_1"
                        // style={{ width: "71% !important" }}
                      >
                        {cell?.row?.original?.log}
                      </div>
                    )}
                  </>
                );
              },
            },

            // {
            //   Header: "Creation Date",

            //   accessor: "requestDate", // accessor is the "key" in the data

            // },
          ]
        : [
            {
              Header: "Id",

              accessor: "id", // accessor is the "key" in the data
              Cell: (cell) => {
                // console.log("cell--", cell.row.index);
                return (
                  <>
                    {cell.row.index +
                      1 +
                      TableStatus?.pageNo * TableStatus?.pageSize}
                  </>
                );
              },
            },

            // {
            //   Header: "Channel",

            //   accessor: "channel", // accessor is the "key" in the data
            // },

            {
              Header: "Request Date",

              accessor: "requestDate", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.requestDate
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span style={{ whiteSpace: "nowrap" }}>
                                {dataaa}
                              </span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },

            // {
            //   Header: "Type",

            //   accessor: "psmstype",
            //   Cell: (cell) => {
            //     return (
            //       <>
            //         {cell?.row?.original?.psmstype == "Promotional" ? (
            //           <div className="">P</div>
            //         ) : (
            //           <div className="">T</div>
            //         )}
            //       </>
            //     );
            //   },
            // },
            {
              Header: "Created Date",

              accessor: "fileCreatedDate", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    <div>
                      {cell?.row?.original?.fileCreatedDate
                        ?.split(" ")
                        ?.map((dataaa) => {
                          return (
                            <>
                              <span style={{ whiteSpace: "nowrap" }}>
                                {dataaa}
                              </span>
                              <br />
                            </>
                          );
                        })}
                    </div>
                  </>
                );
              },
            },

            {
              Header: "Download",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.file_status == 0 ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    )}
                  </>
                );
              },
            },
            // {
            //   Header: "Creation Date",

            //   accessor: "requestDate", // accessor is the "key" in the data

            // },
          ],
    [data, TableStatus.pageNo, TableStatus.pageSize, filterSet]
  );

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const modelButtonReject = useRef();
  const modelButtonReject1 = useRef();

  const callbackFunction1 = (childData) => {
    if (childData?.length > 0) {
      setFilters({
        ...filters,
        toDestination: childData,
      });
    }
  };

  // ....................................Sender Id GetApi............................................................//
  const GetSenderIddetails = async () => {
    try {
      setHideSkeleton(true);
      // alert("working");
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderids`,
        {
          approved: "1",
          resellerName: null,
          type: null,
          pageSize: 10,
          pageNo: 0,
        }
      );
      // console.log("resulttttt222", res);
      if (res.data.statusDescription.statusCode == 200) {
        setHideSkeleton(false);
        // alert("ok");
        // toast.success("api hitted");
        await setDataSenderid(res?.data?.listOfSenderId.content);
        setHideSkeleton(false);
        // toast.error(res.data.statusDescription.statusMessage);
      } else {
        setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription,{
        //   // toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);
      // alert("catch block");
      // console.log(error);
    }
  };

  //.................................... Post Api Filter Button...................................//
  // const FilterBtn = async () => {
  //   setData([]);
  //   let userIds = [];
  //   for (let i = 0; i < userState.length; i++) {
  //     if (userState[i].userId != "all") {
  //       userIds[i] = userState[i].userId;
  //     }
  //   }

  //   try {
  //     //  alert("working");
  //     setOpen1(true);
  //     const res = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/v2/search/byfields`,
  //       {
  //         pdstno: filters.msidn == "" ? null : "91" + filters.msidn,
  //         psrc:
  //           filters?.selector1?.senderId == ""
  //             ? null
  //             : filters?.selector1?.senderId,
  //         smslogid: filters.messageId == "" ? null : filters.messageId,
  //         startDate:
  //           filters?.startDate == null
  //             ? null
  //             : moment(filters?.startDate?.$d)?.format("YYYY-MM-DD"),
  //         endDate:
  //           filters?.endDate == null
  //             ? null
  //             : moment(filters?.endDate?.$d)?.format("YYYY-MM-DD"),

  //         pstatusValues:
  //           filters.statusCheckbox?.Success == true &&
  //           filters.statusCheckbox?.Failed == true
  //             ? [3, 2]
  //             : filters.statusCheckbox?.Success == false &&
  //               filters.statusCheckbox?.Failed == true
  //             ? [2]
  //             : filters.statusCheckbox?.Success == true &&
  //               filters.statusCheckbox?.Failed == false
  //             ? [3]
  //             : null,
  //         pageNo: TableStatus?.pageNo,
  //         pageSize: TableStatus?.pageSize,
  //         uid:
  //           JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
  //           "ROLE_SUPER_ADMIN"
  //             ? userIds?.length > 0
  //               ? userIds
  //               : null
  //             : [JSON.parse(localStorage.getItem("items"))?.uid],
  //         pdate: MenuItemChange?.name,
  //       }
  //     );
  //     // console.log("resulttttt222", res);
  //     if (res.data.statusDescription.statusCode == 200) {
  //       await setData(res.data.playsmsTblSMSOutgoingList.content);
  //       await setData2(res.data.playsmsTblSMSOutgoingList.content);
  //       await setData1(res.data.playsmsTblSMSOutgoingList);
  //       for (
  //         let index = 0;
  //         index < res.data.playsmsTblSMSOutgoingList?.content?.length;
  //         index++
  //       ) {
  //         res.data.playsmsTblSMSOutgoingList.content[index][`Show`] = true;
  //         // arr.push(obj);
  //       }
  //       setOpen1(false);
  //       setDefaultHitPartialSearch(false);
  //       setDefaultHitApi(true);
  //       setTableShow(true);
  //       // setFilters({
  //       //   ...filters,
  //       //   selector1:"",
  //       //   endDate:null,
  //       //   startDate:null,
  //       //   messageId:"",
  //       //   msidn:""
  //       // })
  //       // Swal.fire({
  //       //   icon: "success",
  //       //   //  title: "Oops...",
  //       //   text:res.data.statusDescription.statusMessage,
  //       //   // footer: '<a href="">Why do I have this issue?</a>'
  //       // });
  //     } else {
  //       // toast.error(res.data.statusdescription.statusDescription,{
  //       //   // toastId: customId1,
  //       // });
  //       setOpen1(false);

  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: res.data.statusDescription.statusMessage,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     console.log({ error });
  //     // setHideSkeleton1(false);
  //     setOpen1(false);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Please Check Your Network",
  //     });
  //   }
  // };

  // .........................Partial Search API....................................................................//

  const PartialSearch = async () => {
    setData([]);
    let userIds = [];
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }
    // if(filters.messageId == "" &&
    // filters.msidn == "" &&
    // filters.endDate == null &&
    // filters.startDate == null &&
    // MenuItemChange == null &&
    // filters?.statusCheckbox == null &&
    // userState.length == 0 &&
    // filters?.searchlog == "" &&
    // (filters.selector1 == "" ||
    //   filters.selector1 == null).length > 0)

    try {
      // alert("working");
      setOpen1(true);
      //  setOpen(true);
      setDisableBtn1(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/v2/search/byfields`,

        {
          request: filters.searchlog,
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
          pdstno: filters.msidn == "" ? null : "+222" + filters.msidn,
          psrc:
            filters?.selector1?.senderId == ""
              ? null
              : filters?.selector1?.senderId,
          smslogid: filters.messageId == "" ? null : filters.messageId,
          startDate:
            filters?.startDate == null
              ? null
              : moment(filters?.startDate?.$d)?.format("YYYY-MM-DD"),
          endDate:
            filters?.endDate == null
              ? null
              : moment(filters?.endDate?.$d)?.format("YYYY-MM-DD"),

          pstatusValues: (function () {
            let arr12 = [];
            if (filters.statusCheckbox?.Success) {
              arr12.push(3);
            }
            if (filters.statusCheckbox?.Failed) {
              arr12.push(2);
            }
            return arr12;

            // filters.statusCheckbox?.Success == true &&
            // filters.statusCheckbox?.Failed == true
            //   ? [3, 2]
            //   : filters.statusCheckbox?.Success == false &&
            //     filters.statusCheckbox?.Failed == true
            //   ? [2]
            //   : filters.statusCheckbox?.Success == true &&
            //     filters.statusCheckbox?.Failed == false
            //   ? [3]
            //   : null,
          })(),

          uid:
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
              ? userIds?.length > 0
                ? userIds
                : null
              : [JSON.parse(localStorage.getItem("items"))?.uid],
          pdate: MenuItemChange?.name,
        }
      );
      // console.log("resulttttt222", res);
      if (res.data.statusDescription.statusCode == 200) {
        await setData(res.data.playsmsTblSMSOutgoingList.content);
        // await setData2(res.data.playsmsTblSMSOutgoingList.content);

        await setData1(res.data.playsmsTblSMSOutgoingList);

        for (
          let index = 0;
          index < res.data.playsmsTblSMSOutgoingList?.content?.length;
          index++
        ) {
          res.data.playsmsTblSMSOutgoingList.content[index][`Show`] = true;
          // arr.push(obj);
        }
        setOpen1(false);
        //  setOpen(false);

        setDefaultHitApi(false);
        setDefaultHitPartialSearch(true);
        // setFilters({
        //   ...filters,
        //   searchlog:"",

        // })
        //  Swal.fire({
        //   icon: "success",
        //   //  title: "Oops...",
        //   text:res.data.statusDescription.statusMessage,
        //   // footer: '<a href="">Why do I have this issue?</a>'
        // });
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setData1([]);
        setData2([]);
        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: res.data.statusDescription.statusMessage,
        //   // footer: '<a href="">Why do I have this issue?</a>'
        // });
      } else {
        // alert("pp")
        setOpen1(false);
        //  setOpen(false);

        // toast.error(res.data.statusdescription.statusDescription,{
        //   // toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setHideSkeleton1(false);
      setOpen1(false);
      //  setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  };
  // ..........................................................................................................//
  // console.log("222", defaultHitApi);
  // useEffect(async () => {
  //   if (defaultHitApi == true) {
  //     FilterBtn();
  //   }
  // }, [TableStatus.pageSize, TableStatus.pageNo]);

  useEffect(async () => {
    // alert("11")
    // if (defaultHitPartialSearch == true) {
    //   PartialSearch();
    // }
    if (filterSet == "logs") {
      // alert("old")
      if (JSON.stringify(filters) !== JSON.stringify(initialStatee)) {
        PartialSearch();
      }
    }
    // else if(filterSet=="export"){
    //   alert("end")
    //   ExportBtn();
    // }
  }, [TableStatus.pageSize, TableStatus.pageNo]);
  // ...............................................................................................//

  useEffect(() => {
    GetSenderIddetails();
  }, []);
  useEffect(() => {
    if (disableBtn1 == true && filterSet == "logs") {
      // alert('new')
      PartialSearch();
    }
  }, [filterSet]);
  useEffect(() => {
    // alert("enter")
    if (disableBtn == true && filterSet == "export") {
      // alert('new2')
      ExportBtn();
    } else if (disableBtn == false && filterSet == "export") {
      // alert("11")
      ExportGetApi();
    }
  }, [filterSet, TableStatus.pageSize, TableStatus.pageNo]);

  // .........................................Export Data.......................................................//

  const handleDownload = () => {
    const csvData = `id, smslogId\n${data
      .map((item) => `${item.id}, ${item.smslogId}`)
      .join("\n")}`;
    saveAsCsvFile(csvData, "data.csv");
  };

  const saveAsCsvFile = (csvData, filename) => {
    const csvContent = `data:text/csv;charset=utf-8,${encodeURIComponent(
      csvData
    )}`;
    const link = document.createElement("a");
    link.href = csvContent;
    link.download = filename; // Add ".csv" extension
    link.click();
  };
  // ............................................................................................//
  async function AccountId() {
    try {
      setHideSkeleton1(true);
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
      } else {
        setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setHideSkeleton1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
    ) {
      AccountId();
    }
  }, []);

  // ...............................................................//
  const [showFab, setShowFab] = useState(true);
  const [showFabLeft, setShowFabLeft] = useState(true);
  // console.log("kks", showFab);
  const handleScrollRight = () => {
    const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
    if (table) {
      const nextScrollLeft = table.scrollLeft + 500; // Adjust the scroll amount as needed
      // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
      // setShowFab(false);
      // setShowFabLeft(true);
      table.scroll({
        left: nextScrollLeft,
        behavior: "smooth",
      });
    }
  };
  const handleScroll = () => {
    const table = document.getElementById("tableTarget");
    if (table) {
      if (
        Math.round(table.scrollLeft) <
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(true);
        // setShowFabLeft(false);
      } else if (
        Math.round(table.scrollLeft) ==
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false);
        // setShowFabLeft(true);
      }
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);

  const handleScrollLeft = () => {
    const table = document.getElementById("tableTarget"); // Replace 'myTable' with the actual ID of your table
    if (table) {
      const nextScrollRight = table.scrollRight + 500; // Adjust the scroll amount as needed
      // setShowFab(nextScrollLeft < table.scrollWidth - table.clientWidth);
      // setShowFabLeft(false);
      // setShowFab(true)
      table.scroll({
        left: nextScrollRight,
        behavior: "smooth",
      });
    }
  };

  const handleScroll1 = () => {
    const table = document.getElementById("tableTarget");
    if (table) {
      // console.log(
      //   "tablescroll",
      //   Math.round(table.scrollLeft),
      //   table.scrollWidth - table.clientWidth
      // );
      if (
        Math.round(table.scrollRight) <
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false)
        // setShowFabLeft(true);
      } else if (
        Math.round(table.scrollRight) ==
        table.scrollWidth - table.clientWidth
      ) {
        // setShowFab(false)
        // setShowFabLeft(false);
      }
    }
  };
  useEffect(() => {
    handleScroll1();
  }, []);
  const modelButtonApprove = useRef(null);

  // ...................................................EXport Btn Api........................................................//

  const ExportBtn = async () => {
    let userIds = [];
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }
    try {
      // setHideSkeleton(true);
      // alert("working");
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/download/searchbyfields/report`,
        {
          pdstno: filters.msidn == "" ? null : "+222" + filters.msidn,
          psrc:
            filters?.selector1?.senderId == ""
              ? null
              : filters?.selector1?.senderId,
          smslogid: filters.messageId == "" ? null : filters.messageId,
          pstatusValues:
            filters.statusCheckbox?.Success == true &&
            filters.statusCheckbox?.Failed == true
              ? [3, 2]
              : filters.statusCheckbox?.Success == false &&
                filters.statusCheckbox?.Failed == true
              ? [2]
              : filters.statusCheckbox?.Success == true &&
                filters.statusCheckbox?.Failed == false
              ? [3]
              : null,
          startDate:
            filters?.startDate == null
              ? null
              : moment(filters?.startDate?.$d)?.format("YYYY-MM-DD"),
          endDate:
            filters?.endDate == null
              ? null
              : moment(filters?.endDate?.$d)?.format("YYYY-MM-DD"),
          pdate: MenuItemChange?.name,
          uid:
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
              ? userIds?.length > 0
                ? userIds
                : null
              : [JSON.parse(localStorage.getItem("items"))?.uid],
          request: filters.searchlog,
        }
      );
      // console.log("resulttttt222", res);
      if (res.data.statusDescription.statusCode == 200) {
        ExportGetApi();
        // document.getElementById("export-tab-btn")?.click();
        // setHideSkeleton(false);
        // alert("ok");
        // toast.success("api hitted");
        // await setDataSenderid(res?.data?.listSenderId);
        // setHideSkeleton(false);
        // toast.error(res.data.statusDescription.statusMessage);
      } 
      else if (res.data.statusDescription.statusCode == 220) {
        // ExportGetApi();

        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: res.data.statusDescription.statusMessage,
        //   // footer: '<a href="">Why do I have this issue?</a>'
        // });
      } 
      else {
        // setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription,{
        //   // toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);
      // alert("catch block");
      // console.log(error);
    }
  };
  // .................GetAPI.......................................//
  const ExportGetApi = async () => {
    try {
      // setHideSkeleton(true);
      // alert("working");
      setOpen1(true);
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/v1/download/report/readytodownload?pageNo=${TableStatus.pageNo}&pageSize=${TableStatus.pageSize}`
      );
      // console.log("resulttttt222", res);
      if (res.data.statusDescription.statusCode == 200) {
        await setData(res.data.reportList.content);
        await setData1(res.data.reportList);
        await setData2(res.data.reportList.content);
        await setData3(res.data.reportList);

        setOpen1(false);
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setData1([]);
        setData2([]);
        setData3([]);

        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: res.data.statusDescription.statusMessage,
        //   // footer: '<a href="">Why do I have this issue?</a>'
        // });
      } else {
        // setHideSkeleton(false);
        // toast.error(res.data.statusdescription.statusDescription,{
        //   // toastId: customId1,
        // });
        setOpen1(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusdescription.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton(false);
      // alert("catch block");
      // console.log(error);
    }
  };
  // ...............................................................//

  const downloadFile = async (cell) => {
    // console.log(cell.row.original,"kkjhh")
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.downloadUrl}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // UserId:`${localStorage.getItem('UserId')}`,
            // Source: "web",
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  useEffect(() => {
    if (disableBtn == false && filterSet == "logs") {
      // alert("hi");

      setData([]);
    }
    if (filterSet == "export") {
      // alert("logs");
      setData(data2);
      setData1(data3);
    }
  }, [filterSet]);
  // useEffect(() => {
  //   ExportGetApi()
  // }, [])



  const RefreshBtnApi = async () => {
    setData([]);
    let userIds = [];
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }
if(filterSet == "export")
{
  try {
    // setHideSkeleton(true);
    // alert("working");
    setOpen1(true);
    const res = await common_axios.get(
      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/v1/download/report/readytodownload?pageNo=${TableStatus.pageNo}&pageSize=${TableStatus.pageSize}`
    );
    // console.log("resulttttt222", res);
    if (res.data.statusDescription.statusCode == 200) {
      await setData(res.data.reportList.content);
      await setData1(res.data.reportList);
      await setData2(res.data.reportList.content);
      await setData3(res.data.reportList);

      setOpen1(false);
    } else if (res.data.statusDescription.statusCode == 220) {
      setData([]);
      setData1([]);
      setData2([]);
      setData3([]);

      setOpen1(false);
      // Swal.fire({
      //   icon: "error",
      //   title: "Oops...",
      //   text: res.data.statusDescription.statusMessage,
      //   // footer: '<a href="">Why do I have this issue?</a>'
      // });
    } else {
      // setHideSkeleton(false);
      // toast.error(res.data.statusdescription.statusDescription,{
      //   // toastId: customId1,
      // });
      setOpen1(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.data.statusdescription.statusDescription,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  catch (error) {
    setHideSkeleton(false);
    // alert("catch block");
    // console.log(error);
  }
} else {
  try {
    // alert("working");
    setOpen1(true);
    //  setOpen(true);
    setDisableBtn1(true);

    const res = await common_axios.post(
      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/advance/v1/search/byfields`,

      {
        request: filters.searchlog,
        pageNo: TableStatus?.pageNo,
        pageSize: TableStatus?.pageSize,
        pdstno: filters.msidn == "" ? null : "+222" + filters.msidn,
        psrc:
          filters?.selector1?.senderId == ""
            ? null
            : filters?.selector1?.senderId,
        smslogid: filters.messageId == "" ? null : filters.messageId,
        startDate:
          filters?.startDate == null
            ? null
            : moment(filters?.startDate?.$d)?.format("YYYY-MM-DD"),
        endDate:
          filters?.endDate == null
            ? null
            : moment(filters?.endDate?.$d)?.format("YYYY-MM-DD"),

        pstatusValues: (function () {
          let arr12 = [];
          if (filters.statusCheckbox?.Success) {
            arr12.push(3);
          }
          if (filters.statusCheckbox?.Failed) {
            arr12.push(2);
          }
          return arr12;

          // filters.statusCheckbox?.Success == true &&
          // filters.statusCheckbox?.Failed == true
          //   ? [3, 2]
          //   : filters.statusCheckbox?.Success == false &&
          //     filters.statusCheckbox?.Failed == true
          //   ? [2]
          //   : filters.statusCheckbox?.Success == true &&
          //     filters.statusCheckbox?.Failed == false
          //   ? [3]
          //   : null,
        })(),

        uid:
          JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
          "ROLE_SUPER_ADMIN"
            ? userIds?.length > 0
              ? userIds
              : null
            : [JSON.parse(localStorage.getItem("items"))?.uid],
        pdate: MenuItemChange?.name,
      }
    );
    // console.log("resulttttt222", res);
    if (res.data.statusDescription.statusCode == 200) {
      await setData(res.data.playsmsTblSMSOutgoingList.content);
      // await setData2(res.data.playsmsTblSMSOutgoingList.content);

      await setData1(res.data.playsmsTblSMSOutgoingList);

      for (
        let index = 0;
        index < res.data.playsmsTblSMSOutgoingList?.content?.length;
        index++
      ) {
        res.data.playsmsTblSMSOutgoingList.content[index][`Show`] = true;
        // arr.push(obj);
      }
      setOpen1(false);
      //  setOpen(false);

      setDefaultHitApi(false);
      setDefaultHitPartialSearch(true);
      // setFilters({
      //   ...filters,
      //   searchlog:"",

      // })
      //  Swal.fire({
      //   icon: "success",
      //   //  title: "Oops...",
      //   text:res.data.statusDescription.statusMessage,
      //   // footer: '<a href="">Why do I have this issue?</a>'
      // });
    } else if (res.data.statusDescription.statusCode == 220) {
      setData([]);
      setData1([]);
      setData2([]);
      setOpen1(false);
      // Swal.fire({
      //   icon: "error",
      //   title: "Oops...",
      //   text: res.data.statusDescription.statusMessage,
      //   // footer: '<a href="">Why do I have this issue?</a>'
      // });
    } else {
      // alert("pp")
      setOpen1(false);
      //  setOpen(false);

      // toast.error(res.data.statusdescription.statusDescription,{
      //   // toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.data.statusDescription.statusMessage,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  } catch (error) {
    // setHideSkeleton1(false);
    setOpen1(false);
    //  setOpen(false);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please Check Your Network",
    });
  }
}
 
  };





  const GetChannelList = async () => {
    setHideSkeleton2(true);
    let temp = [];
    try {
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/get/channel?userType=User`
      );
      if (res.data.statusDescription.statusCode == 200) {
        // setChannelList(res.data.userChannels);
        setHideSkeleton2(false);
        let element = res.data.userChannels;
        for (let i = 0; i < element.length; i++) {
          // if (element[i]?.channel != "Email") {
          temp.push(element[i]);
          // }
        }
        // await setChannelList(res.data.userChannels);
        JSON.parse(localStorage.getItem("Sidebaritems")).name ==
        "ROLE_SUPER_ADMIN"
          ? setChannelList(temp)
          : setChannelList(
              JSON.parse(localStorage.getItem("items"))?.userChannelList
            );
      } else {
        setHideSkeleton2(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setHideSkeleton2(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong,Please check your network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // useEffect(() => {
  //   if (
  //     JSON.parse(localStorage.getItem("Sidebaritems")).name ==
  //     "ROLE_SUPER_ADMIN"
  //   ) {
  //     // AccountId();
  //   }
  //   GetChannelList();
  // }, []);
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog modaldialog_2">
                <div className="modal-content">
                  <div className="modal-header ">
                    <h5
                      className="modal-title"
                      id="staticBackdropLabel1 text-center"
                    >
                      Confirmation?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form
                  // onSubmit=
                  // {rejectUserApi}
                  >
                    <div class="modal-body">
                      Are you sure you want to set this as the default?
                    </div>

                    <div className="modal-footer justify-content-between">
                      {/* <div className="row"> */}
                      {/* <div className="col-md-12 text-center"> */}

                      {/* <button
                                                  type="button"
                                                  className="btn btn-secondary m-0"
                                                  data-bs-dismiss="modal"
                                                  id="getcancel"
                                                  onClick={() => {
                                                    setSelectedUserDetailApprove(
                                                      undefined
                                                    );
                                                  }}
                                                >
                                                  Cancel
                                                </button> */}

                      <button
                        type="button"
                        className="btn btn-secondary m-0 shadow"
                        data-bs-dismiss="modal"
                      >
                        No
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary editcolor shadow okbtn px-3"
                        data-bs-dismiss="modal"
                        // onClick={async () => {
                        //                   if (
                        //                     arg.twoFactorAuthenticationType ==
                        //                     "Google Authenticator"
                        //                   ) {
                        //                     await MobileNumberGenerator(arg);
                        //                     setModelScannerState(arg);
                        //                     setGoogleAuthIndex(index);
                        //                     modelScan2.current.click();
                        //                   } else {
                        //                     PostVerifyApi(arg, index);
                        //                   }
                        //                 }}
                        onClick={() => {
                          // ExportBtn();
                          document.getElementById("export-tab-btn")?.click();

                          setDisableBtn(true);
                          setTableStatus({
                            ...TableStatus,
                            pageNo: 0,
                            pageSize: 10,
                          });
                        }}
                      >
                        Confirm
                      </button>

                      {/* </div> */}
                      {/* </div> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            className="p-4"
            id="advance_search_card"
            style={{ marginLeft: "320px" }}
          ></div>

          <div className="container-fluid px-0" style={{ marginTop: "-30px" }}>
            <div className="ro mx-0">
              {/* <div className="co px-0"> */}
              <div
                className="card card_scroll rounded-0"
                style={{ borderRadius: "0" }}
              >
                <div class="container-fluid px-4" id="calender_log">
                  <div className="row mt-3">
                    <div class="d-flex justify-content-between px-0">
                      <div class="bd-highlight px-0">
                        <div className="d-flex align-items-center">
                          <FilterAltIcon style={{ fontSize: "17px" }} />
                          <h4 className="w-100 ms-2">Filters</h4>
                        </div>
                      </div>

                      <div class=" bd-highlight px-0">
                        <button
                          type="button"
                          class="btn btn-lg px-0"
                          onClick={() => {
                            setFilters({
                              ...filters,
                              exactMatch: true,
                              messageId: "",
                              msidn: "",
                              viewMore: true,
                              selector1: "",
                              startDate: null,
                              endDate: null,
                              statusCheckbox: null,
                              toDestination: "",
                              fromDestination: [],
                              showMoreFilters: false,
                            });
                          }}
                          style={{
                            color: "#48A8DD",
                            textDecoration: "underline",
                          }}
                        >
                          Reset Filters
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <div class="row mt-3 ps-0">
                    <p className="fw-bold p-0">Search Options</p>
                  </div>

                  <div class="row mt-2" style={{ paddingLeft: "auto" }}>
                    <div class="form-check">
                      <input
                        style={{
                          padding: 0,
                        }}
                        value={filters?.exactMatch}
                        onChange={(e) => {
                          setFilters({
                            ...filters,

                            exactMatch: e.target.checked,
                          });
                        }}
                        class="form-check-input"
                        type="checkbox"
                        id="flexCheckIndeterminate"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckIndeterminate"
                      >
                        Find messages with exact match
                      </label>
                    </div>
                  </div> */}
                  <div>
                    {/* <button onClick={handleDownload}>Download Excel</button> */}
                  </div>
                  <div className="row mt-2">
                    <div className="d-flex p-0" id="inp_merge">
                      <input className="inpt_width" disabled value="+222" />

                      <TextField
                        fullWidth
                        className="w-100"
                        label="Mobile Number"
                        name="senderId"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={filters.msidn}
                        onChange={(e) => {
                          setFilters({
                            ...filters,
                            msidn: e.target.value,
                          });
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.slice(0, 10);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <TextField
                      fullWidth
                      className="w-100"
                      label="Message Id"
                      name="senderId"
                      variant="outlined"
                      size="small"
                      type="text"
                      value={filters.messageId}
                      onChange={(e) => {
                        setFilters({
                          ...filters,
                          messageId: e.target.value,
                        });
                      }}
                    />
                  </div>

                  <div class="row mt-3" id="senderidsearch">
                    <>
                      {hideSkeleton == true ? (
                        <>
                          <Box sx={{ width: "100%" }}>
                            <Skeleton />
                            <Skeleton animation="wave" />
                            {/* <Skeleton animation={false} /> */}
                          </Box>
                        </>
                      ) : (
                        <>
                          {" "}
                          <Autocomplete
                            disablePortal
                            disableListWrap={true}
                            aria-required
                            className="w-100"
                            id="combo-box-demo"
                            size="small"
                            options={dataSenderid}
                            // value={list}
                            value={filters?.selector1}
                            getOptionLabel={(option) => option.senderId || ""}
                            // onChange={(e, value) => handlechange(value)}
                            onChange={(e, value) => {
                              setFilters({
                                ...filters,

                                selector1: value,
                              });
                            }}
                            sx={{ width: 300 }}
                            renderInput={(params) => (
                              <TextField
                                // required
                                {...params}
                                label="Sender Id"
                              />
                            )}
                          />
                        </>
                      )}
                    </>
                  </div>
                  {/* <div class="row mt-3" >
                  {hideSkeleton2 == true ? (
                    <>
                      <Box sx={{ width: "25%" }}>
                        <Skeleton />
                        <Skeleton animation="wave" />
                      </Box>
                    </>
                  ) : (
                    <>
                   
                        <Autocomplete
                          aria-required
                          size="small"
                          fullWidth
                          value={channelState}
                          className="w-100"

                          onChange={(e, val) => {
                            setChannelState(val);
                          }}
                          multiple
                          limitTags={2}
                          id="multiple-limit-tags"
                          options={channelList}
                          renderOption={(params) => {
                            return (
                              <>
                                {loading ? (
                                  <Skeleton animation="wave" />
                                ) : (
                                  <>
                                    <div
                                      className="d-flex justify-content-between"
                                      {...params}
                                    >
                                      <div className12="col-md-2">
                                        <Checkbox
                                          checked={channelState?.some(
                                            (film) =>
                                              film?.channel === params?.key
                                          )}
                                        />
                                      </div>
                                      <div className12="col-md-10">
                                        <p class="fs-5">{params?.key}</p>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </>
                            );
                          }}
                          getOptionLabel={(option) => option?.channel || ""}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              fullWidth
                              {...params}
                              label="Channel"
                           
                            />
                          )}
                        />
                     
                    </>
                  )}
                  </div> */}
               


                  <div class="row log_cal mt-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          // disablePast
                          label="Start Date"
                          value={filters?.startDate}
                          disableFuture
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setFilters({
                              ...filters,

                              startDate: newValue,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              // onKeyDown={onKeyDown}
                              {...params}
                              helperText={
                                filters.startDate == null &&
                                filters.endDate != null && (
                                  <span style={{ color: "red" }}>
                                    When you selected end date (start date) is
                                    mandatory
                                  </span>
                                )
                              }
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>

                  <div class="row log_cal mt-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          // disablePast
                          label="End Date"
                          disableFuture
                          value={filters?.endDate}
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setFilters({
                              ...filters,
                              endDate: newValue,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              // onKeyDown={onKeyDown}
                              {...params}
                              helperText={
                                filters.startDate != null &&
                                filters.endDate == null && (
                                  <span style={{ color: "red" }}>
                                    When you selected start date (end date) is
                                    mandatory
                                  </span>
                                )
                              }
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>

                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        size="small"
                        renderInput={(props) => (
                          <TextField size="small" {...props} />
                        )}
                        label="End Time"
                        onChange={(newValue) => {
                          setFilters({
                            ...filters,

                            endDate: newValue,
                          });
                        }}
                        value={filters?.endDate}
                      />
                    </LocalizationProvider> */}
                  </div>

                  {/* <div class="row mt-4">
                    <div className="col-md-6 ps-0">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          size="small"
                          renderInput={(props) => (
                            <TextField size="small" {...props} />
                          )}
                          label="End Time"
                          // value={value}
                          // onChange={(newValue) => {
                          //   setValue(newValue);
                          // }}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="col-md-6 pe-0">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          size="small"
                          renderInput={(props) => (
                            <TextField size="small" {...props} />
                          )}
                          label="End Time"
                          // value={value}
                          // onChange={(newValue) => {
                          //   setValue(newValue);
                          // }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div> */}
                  {MoreFilters == true ? (
                    <>
                      <div className="text-center mt-3">
                        <a
                          class="fw-bold"
                          style={{
                            cursor: "pointer",
                            color: "#0060df",
                            textDecoration: "underline",
                          }}
                          // onClick={setMoreFilters(true)}
                          onClick={() => {
                            setMoreFilters(false);
                          }}
                        >
                          View Less Filters
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="text-center mt-3">
                        <a
                          class="fw-bold"
                          style={{
                            cursor: "pointer",
                            color: "#0060df",
                            textDecoration: "underline",
                          }}
                          // onClick={setMoreFilters(true)}
                          onClick={() => {
                            setMoreFilters(true);
                          }}
                        >
                          View More Filters
                        </a>
                      </div>
                    </>
                  )}

                  {MoreFilters == true && (
                    <>
                      <div
                        class="row mx-0 mt-4"
                        style={{ borderBottom: "1px solid" }}
                      >
                        <div class="form-check px-0">
                          <div class="d-flex justify-content-between">
                            <div>
                              <label
                                class="form-check-label fw-bold"
                                for="flexCheckDefault"
                              >
                                Status
                              </label>
                            </div>

                            <div>
                              <input
                                onChange={(e) => {
                                  e.target.checked == true
                                    ? setFilters({
                                        ...filters,

                                        statusCheckbox: {
                                          ...filters.statusCheckbox,
                                          Success: true,
                                          Failed: true,
                                        },
                                      })
                                    : setFilters({
                                        ...filters,

                                        statusCheckbox: null,
                                      });
                                }}
                                checked={
                                  filters?.statusCheckbox?.["Success"] &&
                                  filters?.statusCheckbox?.["Failed"]
                                }
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {[
                        {
                          id: 0,
                          name: "Success",
                          value: "Success",
                        },
                        {
                          id: 0,
                          name: "Failed",
                          value: "Failed",
                        },
                      ]?.map((ddata) => {
                        return (
                          <div class="row mx-0 mt-2">
                            <div class="form-check px-0">
                              <div class="d-flex justify-content-between">
                                <div>
                                  <label
                                    class="form-check-label"
                                    for="flexCheckDefault"
                                  >
                                    {ddata.name}
                                  </label>
                                </div>

                                <div>
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    name={ddata.name}
                                    checked={
                                      filters?.statusCheckbox?.[ddata.name]
                                    }
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,

                                        statusCheckbox: {
                                          ...filters.statusCheckbox,
                                          [e.target.name]: e.target.checked,
                                        },
                                      });
                                    }}
                                    value={ddata.value}
                                    id="flexCheckDefault"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <Autocomplete
                        disablePortal
                        disableListWrap={true}
                        aria-required
                        className="w-100"
                        id="combo-box-demo"
                        size="small"
                        options={[
                          {
                            id: 0,
                            name: "Last 15 minutes",
                            value: "Last 15 minutes",
                          },
                          {
                            id: 0,
                            name: "Last 3 hours",
                            value: "Last 3 hours",
                          },
                          {
                            id: 0,
                            name: "Last 6 hours",
                            value: "Last 6 hours",
                          },
                          {
                            id: 0,
                            name: "Last 24 hours",
                            value: "Last 24 hours",
                          },
                          {
                            id: 0,
                            name: "Today so far",
                            value: "Today so far",
                          },
                          {
                            id: 0,
                            name: "Yesterday",
                            value: "Yesterday",
                          },
                          {
                            id: 0,
                            name: "Last 7 days",
                            value: "Last 7 days",
                          },
                          {
                            id: 0,
                            name: "Last 30 days",
                            value: "Last 30 days",
                          },
                          {
                            id: 0,
                            name: "This week is so far",
                            value: "This week is so far",
                          },
                          {
                            id: 0,
                            name: "Last week",
                            value: "Last week",
                          },
                          {
                            id: 0,
                            name: "Last month",
                            value: "Last month",
                          },
                        ]}
                        // value={list}
                        value={MenuItemChange}
                        getOptionLabel={(option) => option.name || ""}
                        // onChange={(e, value) => handlechange(value)}
                        onChange={(e, value) => {
                          setMenuItemChange(value);
                        }}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            // required
                            {...params}
                            label="Date"
                          />
                        )}
                      />

                      {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
                      "ROLE_SUPER_ADMIN" ? (
                        <>
                          {hideSkeleton1 == true ? (
                            <>
                              <Box sx={{ width: "25%" }}>
                                <Skeleton />
                                <Skeleton animation="wave" />
                                {/* <Skeleton animation={false} /> */}
                              </Box>
                            </>
                          ) : (
                            <>
                              <div className="col-md-12 mt-3">
                                <Autocomplete
                                  aria-required
                                  // disabled={MenuItemPhoneBook==undefined}
                                  size="small"
                                  fullWidth
                                  value={userState}
                                  onChange={(e, val) => {
                                    setUserState(val);
                                  }}
                                  multiple
                                  limitTags={2}
                                  id="multiple-limit-tags"
                                  options={accountidvalue}
                                  getOptionDisabled={(option) =>
                                    userState?.[0]
                                      ? userState?.[0]?.userName === "All"
                                        ? option.userName !== "All"
                                        : option.userName === "All"
                                      : null
                                  }
                                  getOptionLabel={(option) => option?.userName}
                                  // defaultValue={mappingArray}
                                  renderInput={(params) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...params}
                                      label="User Name List"
                                    />
                                  )}
                                />
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="col-md-12 mt-3">
                            <TextField
                              required
                              disabled
                              className="w-100"
                              label="Name"
                              variant="outlined"
                              size="small"
                              value={localStorage.getItem("usernamedisplayed")}
                              type="text"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Name"
                                      placement="top"
                                      arrow
                                      sx={{ color: "#85CBF2" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {/* <div class="row mt-3">
                    <div class="text-center px-0">
                      <button
                        onClick={() => {
                          setFilters({
                            ...filters,
                            showMoreFilters: !filters?.showMoreFilters,
                          });
                        }}
                        type="button"
                        class="btn p-0 btn-lg"
                        style={{
                          color: "#48A8DD",
                          textDecoration: "underline",
                        }}
                      >
                        {!filters?.showMoreFilters
                          ? "View more filters"
                          : "View Less filters"}
                      </button>
                    </div>
                  </div> */}

                  {/* <div className="row mt-3">
                    <LogsMultiSelect categoryy="Promotional" />
                  </div>

                  <div className="row mt-3">
                    <LogsMultiSelect categoryy="Promotional" />
                  </div> */}

                  {/* {filters?.showMoreFilters ? (
                    <> */}
                  {/* 
                  <div className="row mt-3">
                    <TextField
                      fullWidth
                      className="w-100"
                      label="To Destination[Mobile Number]"
                      name="senderId"
                      variant="outlined"
                      size="small"
                      type="number"
                      value={filters.toDestination}
                      onChange={(e) => {
                        setFilters({
                          ...filters,
                          toDestination: e.target.value,
                        });
                      }}
                    />
                  </div> */}

                  {/* <div className="row mt-3">
                    <LogsMultiSelect
                      categoryy="Promotional"
                      labelName="From"
                      parentCallback={callbackFunction1}
                    />
                  </div> */}
                  {/* </>
                  ) : null} */}

                  {/* <div className="row my-3">
                    <div className="text-end">
                      <button
                        style={{ background: "#1990d0" }}
                        disabled={
                          JSON.parse(localStorage.getItem("Sidebaritems"))
                            .name == "ROLE_SUPER_ADMIN"
                            ? filters.messageId == "" &&
                              filters.msidn == "" &&
                              filters.endDate == null &&
                              filters.startDate == null &&
                              MenuItemChange == null &&
                              filters?.statusCheckbox == null &&
                              userState.length == 0 &&
                              (filters.selector1 == "" ||
                                filters.selector1 == null)
                            : false
                        }
                        type="button"
                        className="btn bg-gradient-primary m-0"
                        onClick={() => {
                          setTableStatus({
                            ...TableStatus,
                            pageNo: 0,
                            pageSize: 10,
                          });
                          FilterBtn();
                        }}
                      >
                        Filter
                        <FilterAltIcon style={{ fontSize: "17px" }} />
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* </div> */}
              <div className="co p-4 py-0" style={{ marginLeft: "320px" }}>
                <div className="card mb-3">
                  <div className="card-body py-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <BookIcon style={{ fontSize: "17px" }} />
                        <h4 className="w-100 ms-2">Logs</h4>
                      </div>
                      <button
                        type="submit"
                        className="btn bg-gradient-primary m-0"
                        // onClick={handleDownload}
                        onClick={() => {
                          modelButtonApprove.current.click();
                        }}
                        disabled={
                          (filters.startDate != null &&
                            filters.endDate == null) ||
                          (filters.startDate == null &&
                            filters.endDate != null) ||
                          (JSON.parse(localStorage.getItem("Sidebaritems"))
                            .name == "ROLE_SUPER_ADMIN"
                            ? filters.messageId == "" &&
                              filters.msidn == "" &&
                              filters.endDate == null &&
                              filters.startDate == null &&
                              MenuItemChange == null &&
                              filters?.statusCheckbox == null &&
                              userState.length == 0 &&
                              filters?.searchlog == "" &&
                              (filters.selector1 == "" ||
                                filters.selector1 == null)
                            : filters.messageId == "" &&
                              filters.msidn == "" &&
                              filters.endDate == null &&
                              filters.startDate == null &&
                              MenuItemChange == null &&
                              filters?.statusCheckbox == null &&
                              userState.length == 0 &&
                              filters?.searchlog == "" &&
                              (filters.selector1 == "" ||
                                filters.selector1 == null))
                        }
                      >
                        Export
                        <DownloadIcon style={{ fontSize: "17px" }} />
                      </button>
                    </div>
                    {/* <div className="text-end">
                              
                              
                            </div> */}
                    <div className="card-body text-lg-start text-center px-0">
                      <form
                        // onSubmit={formik.handleSubmit}
                        className="row g-3 needs-validation"
                      >
                        <div className="col-md-12">
                          <div
                            className="d-flex align-items-center p-3 py-2"
                            style={{
                              border: "1px solid #48a8dd",
                              // background: "white",
                              borderRadius: "8px",
                              boxShadow: "0 0 1px 1px lightblue",
                            }}
                          >
                            <SearchIcon
                              style={{
                                width: "1em",
                                height: "1em",
                              }}
                            />
                            <input
                              type="search"
                              placeholder="Search by message id, email subject, sender name, destination or data payload..."
                              className="form-control border-0"
                              role="searchbox"
                              style={{
                                width: "100%",
                                border: "none !important",
                                padding: "0",
                                fontSize: "14px",
                                lineHeight: "normal",
                              }}
                              value={filters?.searchlog}
                              onKeyDown={(event) => {
                                if (event.key == "Enter") {
                                  PartialSearch();
                                }
                              }}
                              // value={paginationState?.searchValue}
                              onChange={(event) => {
                                // onChange(event.target.value);
                                setFilters({
                                  ...filters,
                                  searchlog: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="text-end">
                          <button
                            style={{ background: "#1990d0" }}
                            // disabled={filters?.searchlog == ""}
                            disabled={
                              (filters.startDate != null &&
                                filters.endDate == null) ||
                              (filters.startDate == null &&
                                filters.endDate != null) ||
                              (JSON.parse(localStorage.getItem("Sidebaritems"))
                                .name == "ROLE_SUPER_ADMIN"
                                ? filters.messageId == "" &&
                                  filters.msidn == "" &&
                                  filters.endDate == null &&
                                  filters.startDate == null &&
                                  MenuItemChange == null &&
                                  filters?.statusCheckbox == null &&
                                  userState.length == 0 &&
                                  filters?.searchlog == "" &&
                                  (filters.selector1 == "" ||
                                    filters.selector1 == null)
                                : filters.messageId == "" &&
                                  filters.msidn == "" &&
                                  filters.endDate == null &&
                                  filters.startDate == null &&
                                  MenuItemChange == null &&
                                  filters?.statusCheckbox == null &&
                                  userState.length == 0 &&
                                  filters?.searchlog == "" &&
                                  (filters.selector1 == "" ||
                                    filters.selector1 == null))
                            }
                            type="button"
                            className="btn bg-gradient-primary m-0"
                            onClick={() => {
                              setTableStatus({
                                ...TableStatus,
                                pageNo: 0,
                                pageSize: 10,
                              });
                              PartialSearch();
                              document.getElementById("log-tab-btn")?.click();
                            }}
                          >
                            Search
                            <SearchIcon style={{ fontSize: "17px" }} />
                          </button>
                        </div>
                      </form>
                    </div>

                    {/* {data.length > 0 && ( */}

                    {tableShow == false && defaultHitPartialSearch == false ? (
                      <></>
                    ) : (
                      <>
                        <>
                          {" "}
                          <div className="container-fluid p-0 mt-3">
                            <div className="d-flex align-items-center">
                              <EmailIcon style={{ fontSize: "17px" }} />
                              <h4 className="w-100 ms-2">Messages</h4>
                            </div>
                            <div className="card shadow-none border bg_blue mt-3">
                              {/* <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                            Messages
                          </span> */}

                              <ul
                                className="nav nav-tabs  flex-row p-3"
                                id="myTab"
                                role="tablist"
                              >
                                <li
                                  className="nav-item list_1"
                                  role="presentation"
                                >
                                  <button
                                    className={
                                      filterSet == "logs"
                                        ? "nav-link active"
                                        : "nav-link"
                                    }
                                    type="button"
                                    id="log-tab-btn"
                                    onClick={() => {
                                      // setResetValue(!resetValue);
                                      setFilterSet("logs");
                                      // FilterBtn()
                                      // setDisableBtn(false)
                                      setPaginationPage(1);
                                      setTableStatus({
                                        ...TableStatus,
                                        pageNo: 0,
                                        pageSize: 10,
                                      });
                                    }}
                                  >
                                    Logs
                                  </button>
                                </li>
                                <li
                                  className="nav-item list_1"
                                  role="presentation"
                                >
                                  <button
                                    className={
                                      filterSet == "export"
                                        ? "nav-link active ms-2"
                                        : "nav-link ms-2"
                                    }
                                    type="button"
                                    id="export-tab-btn"
                                    // disabled={disableBtn==false}
                                    onClick={() => {
                                      // setResetValue(!resetValue);
                                      setPaginationPage(1);
                                      setFilterSet("export");

                                      setTableStatus({
                                        ...TableStatus,
                                        pageNo: 0,
                                        pageSize: 10,
                                      });
                                    }}
                                  >
                                    Export
                                  </button>
                                </li>
                              </ul>

                              {data.length == 0 && open1 ? (
                                <>
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </>
                              ) : null}

                              {data.length > 0 ? (
                                <div className="p-4">
                                  <div className="d-flex justify-content-between my-3">
                                    <select
                                      value={TableStatus.pageSize}
                                      className="dropdown"
                                      onChange={(e) => {
                                        setPageSize(Number(e.target.value));
                                        setTableStatus({
                                          ...TableStatus,
                                          pageSize: e.target.value,
                                        });
                                      }}
                                    >
                                      {[10, 25, 50].map((value, i) => {
                                        return (
                                          <option
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton1"
                                            value={value}
                                            key={value}
                                          >
                                            Show {value}
                                          </option>
                                        );
                                      })}
                                    </select>

                                    <Tooltip title="Refresh">
                  <button
                    type="submit"
                    className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                     onClick={() => RefreshBtnApi("Text to Copy")}
                  >
                    {/* <i class="material-icons opacity-10">refresh</i> */}
                    <RefreshIcon />
                  </button>
                </Tooltip>
                                  </div>

                                  <div
                                    style={{
                                      position: "sticky",
                                      top: "0px",
                                      zIndex: "9",
                                    }}
                                  >
                                    <div class="d-flex justify-content-between">
                                      <div>
                                        {showFabLeft && (
                                          <Fab
                                            // className="fab position-sticky"
                                            onClick={handleScrollLeft}
                                            // color="primary"
                                            style={{
                                              backgroundColor:
                                                "rgb(89 144 175)",
                                              color: "white",
                                              width: "31px",
                                              height: "31px",
                                              position: "sticky",
                                              top: "0",
                                              right: "0",
                                              // marginTop: "46px"
                                            }}
                                            // aria-label="add"
                                          >
                                            <ArrowLeftIcon
                                              style={{ fontSize: "23px" }}
                                            />
                                          </Fab>
                                        )}
                                      </div>
                                      <div>
                                        {showFab && (
                                          <Fab
                                            // className="fab position-sticky"
                                            onClick={handleScrollRight}
                                            // color="primary"
                                            style={{
                                              backgroundColor:
                                                "rgb(89 144 175)",
                                              color: "white",
                                              position: "sticky",
                                              top: "0",
                                              right: "0",
                                              width: "31px",
                                              height: "31px",
                                            }}
                                            // aria-label="add"
                                          >
                                            <ArrowRightIcon
                                              style={{ fontSize: "23px" }}
                                            />
                                            {/* <PlayArrowIcon /> */}
                                          </Fab>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="table-responsive position-relative mt-2"
                                    id="tableTarget"
                                    style={{ textAlign: "right" }}
                                    //  onScroll={handleScroll}
                                    onScroll={() => {
                                      handleScroll();
                                      handleScroll1();
                                    }}
                                  >
                                    {open1 ? (
                                      <>
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                      </>
                                    ) : (
                                      <>
                                        {" "}
                                        <table
                                          {...getTableProps()}
                                          id="example"
                                          className="table table-striped table-bordered dataTable table-sm"
                                          style={{ width: "100%" }}
                                        >
                                          <thead>
                                            {headerGroups.map((headerGroup) => (
                                              <tr
                                                {...headerGroup.getHeaderGroupProps()}
                                              >
                                                {headerGroup.headers.map(
                                                  (column) => (
                                                    <th
                                                      {...column.getHeaderProps(
                                                        column.getSortByToggleProps()
                                                      )}
                                                      // className="text-center width_2"
                                                      className={
                                                        column?.Header ==
                                                        "Message"
                                                          ? "text-center width_2 update_th messageWidth"
                                                          : column?.Header ==
                                                            "Type"
                                                          ? "text-center width_2 update_th_sp d-flex border-start-0"
                                                          : "text-center width_2 update_th_sp"
                                                      }
                                                    >
                                                      {column.render("Header")}
                                                      <span>
                                                        {column.isSorted
                                                          ? column.isSortedDesc
                                                            ? "↑"
                                                            : "↓"
                                                          : ""}
                                                      </span>
                                                      {column.Header ==
                                                      "Type" ? (
                                                        <>
                                                          <InputAdornment
                                                            position="end"
                                                            className="my-auto"
                                                          >
                                                            {/* {`(${cell?.row?.original?.username})`} */}
                                                            <Tooltip
                                                              // title={`Promotional-P ${<br/>} Transactional-T`}
                                                              // title={`(${Promotional-P})`<br> `(${Promotional-P})`}
                                                              title={"P-Promotional T-Transactional"
                                                                .split(" ")
                                                                .map((arg) => {
                                                                  return (
                                                                    <>
                                                                      {arg}
                                                                      <br />
                                                                    </>
                                                                  );
                                                                })}
                                                              id="toolTipId"
                                                              placement="top"
                                                              arrow
                                                              sx={{
                                                                color: "white",
                                                              }}
                                                            >
                                                              <InfoIcon />
                                                            </Tooltip>
                                                          </InputAdornment>
                                                        </>
                                                      ) : (
                                                        <></>
                                                      )}
                                                    </th>
                                                  )
                                                )}
                                              </tr>
                                            ))}
                                          </thead>
                                          <tbody
                                            class="onhover_change"
                                            {...getTableBodyProps()}
                                          >
                                            {page.map((row) => {
                                              prepareRow(row);
                                              return (
                                                <tr {...row.getRowProps()}>
                                                  {row.cells.map((cell) => {
                                                    return (
                                                      <td
                                                        {...cell.getCellProps()}
                                                        // className="text-center"
                                                        className={
                                                          cell.column.Header ==
                                                            "Sender Id" ||
                                                          cell.column.Header ==
                                                            "Total Sms" ||
                                                          cell.column.Header ==
                                                            "Sms Success" ||
                                                          cell.column.Header ==
                                                            "Sms Fail"
                                                            ? "text-end update_td"
                                                            : cell.column
                                                                .Header ==
                                                                "Status" ||
                                                              cell.column
                                                                .Header ==
                                                                "Download" ||
                                                              cell.column
                                                                .Header ==
                                                                "Download" ||
                                                              cell.column
                                                                .Header ==
                                                                "Id" ||
                                                              cell.column
                                                                .Header ==
                                                                "Type"
                                                            ? "text-center update_td"
                                                            : "text-start update_td"
                                                        }
                                                      >
                                                        {cell.render("Cell")}
                                                      </td>
                                                    );
                                                  })}
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                        <div className="d-flex justify-content-between mt-2">
                                          <div>
                                            <span>
                                              Page:
                                              <strong>
                                                {data1?.pageable?.pageNumber +
                                                  1}{" "}
                                                of {data1?.totalPages}
                                              </strong>
                                            </span>
                                          </div>

                                          <div className="prev_next d-flex align-items-center">
                                            <button
                                              className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                                              type="button"
                                              // style={{ background: "#2C97D4" }}
                                              //  disabled={data1?.pageable?.pageNumber == 0}
                                              onClick={() => {
                                                setTableStatus({
                                                  ...TableStatus,
                                                  pageNo: 0,
                                                });
                                                setPaginationPage(1);
                                              }}
                                            >
                                              First
                                            </button>

                                            <Stack spacing={2}>
                                              <Pagination
                                                onChange={(event, value) => {
                                                  // console.log("va--", value);
                                                  setTableStatus({
                                                    ...TableStatus,
                                                    pageNo: Number(value) - 1,
                                                  });
                                                  setPaginationPage(value);
                                                }}
                                                page={paginationPage}
                                                count={
                                                  data1 ? data1?.totalPages : ""
                                                }
                                                variant="outlined"
                                                shape="rounded"
                                                color="primary"
                                              />
                                            </Stack>
                                            <button
                                              className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                                              type="button"
                                              // style={{ background: "#2C97D4" }}
                                              // disabled={
                                              //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                                              //  }
                                              onClick={() => {
                                                // alert("gg")
                                                setTableStatus({
                                                  ...TableStatus,
                                                  pageNo: data1?.totalPages - 1,
                                                });
                                                setPaginationPage(
                                                  data1?.totalPages
                                                );
                                              }}
                                            >
                                              Last
                                            </button>
                                          </div>

                                          {/* <div className="btn_n800">
                                      <button
                                        className="btn btn_primary "
                                        type="button"
                                        style={{ background: "#2C97D4" }}
                                        disabled={
                                          data1?.pageable?.pageNumber == 0
                                        }
                                        onClick={() => {
                                          setTableStatus({
                                            ...TableStatus,
                                            pageNo: TableStatus.pageNo - 1,
                                          });
                                        }}
                                      >
                                        Prev
                                      </button>

                                      <button
                                        className="btn btn_primary ms-2"
                                        type="button"
                                        style={{ background: "#2C97D4" }}
                                        disabled={
                                          data1?.totalPages ==
                                          data1?.pageable?.pageNumber + 1
                                        }
                                        onClick={() => {
                                          setTableStatus({
                                            ...TableStatus,
                                            pageNo: TableStatus.pageNo + 1,
                                          });
                                        }}
                                      >
                                        Next
                                      </button>
                                    </div> */}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {data?.length == 0 && open ? null : (
                                    <div className="text-center">
                                      <h5>No Record Found..!!</h5>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      </>
                    )}

                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div
                      className="tab-pane fade"
                      id="SenderMasking"
                      role="tabpanel"
                      aria-labelledby="SenderMasking-tab"
                    >
                      <DownloadLogs/>
                    </div> */}
        </ThemeProvider>
      </main>
    </>
  );
}
